import React from "react";
import { translateText } from "../../../../../Helper_functions";

const OtherServices = (props) => {
  return (
    <div className="table-wrapper ai-services-table-wrapper">
      <div className="table-head ai-services-table-head">
        {translateText("other_services", props.LangData)}
      </div>
      <div className="table-content other-services">
        {translateText("currently_unavailable", props.LangData)}
      </div>
    </div>
  );
};

export default OtherServices;
